﻿import Repository from "./Repository";

const loginResource = "login";
const requestPasswordResource = "request-password";
const resetPasswordResource = "reset-password";

export default {
  login(loginFormData, headers) {
    return Repository.post(loginResource, loginFormData, headers);
  },
  requestNewPassword(email) {
    var fd = new FormData();
    fd.append("email", email);
    return Repository.post(requestPasswordResource, fd);
  },
  resetPassword(newPass, token) {
    var fd = new FormData();
    fd.append("newPassword", newPass);
    fd.append("token", token);
    return Repository.post(resetPasswordResource, fd);
  },
};
